export default __webpack_public_path__ + "static/media/code.69de8cd1.jpg";